export default __webpack_public_path__ + "static/media/leaderboard.5a1bce8f.svg";